import React from 'react';
import './index.css';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import AppRoutes from './routes/Routes';
import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <div className="page-wrapper">
      <ScrollToTop />
      <Header />
      <main>
        {/* <Home /> */}
        <AppRoutes />
        
      </main>
      <Footer />
    </div>
  );
}

export default App;
